// The annual increases booked for a building, for the account card (item #706).
// Reads the rate changes that belong to an annual increase and are Scheduled;
// scheduledIncreaseFrom() does the sum where the card's figure is known. A
// failed read shows nothing extra — the card's own figure is unaffected, and
// nothing here can be saved.
import { useEffect, useState } from 'react';
import { supabase } from '../../../shared/supabase';
import type { scheduledIncreaseFrom } from './annual-increase';

type BookedRows = Parameters<typeof scheduledIncreaseFrom>[0];

export function useScheduledAnnualIncreaseRows(facilityId: string | null | undefined): BookedRows {
  const [rows, setRows] = useState<BookedRows>([]);
  useEffect(() => {
    if (!facilityId) return;
    let cancelled = false;
    void (async () => {
      const { data, error } = await supabase
        .from('rate_change_proposals')
        .select('status, kv_id, field_name, effective_date, current_value, proposed_value')
        .eq('facility_id', facilityId)
        .eq('status', 'Scheduled')
        .not('kv_id', 'is', null);
      if (cancelled) return;
      if (error) {
        console.warn('[annual-increase] scheduled lookup failed', error.message);
        setRows([]);
        return;
      }
      setRows(data ?? []);
    })();
    return () => {
      cancelled = true;
    };
  }, [facilityId]);
  return rows;
}
